import goalsService from '@/services/goalsService.js'; // Ensure you have this service

export default {
  // No namespacing as per your preference
  state: () => ({
    showGoalsModal: false,

  }),
  mutations: {
    setShowGoalsModal(state, bool){
        state.showGoalsModal = bool;
      },
  },
  actions: {
    async editGoal({ commit, dispatch }, goal){
        await goalsService.editGoal(goal);
        commit('setShowGoalsModal', false);
        await dispatch('getGoals', goal.project_id);
 
     },
     setShowGoalsModal({commit}, payload){
        commit('setShowGoalsModal', payload);
      },
  },
  getters: {
    showGoalsModal: (state) => state.showGoalsModal,
  },
};
